import {useMutation} from "@apollo/client";
import {ConfirmHandlingEditorDocument, ConfirmHandlingEditorInput} from "generated/graphql";

export const useConfirmHandlingEditor = () => {
  const [mutate] = useMutation(ConfirmHandlingEditorDocument);

  return (input: ConfirmHandlingEditorInput) => mutate({ variables: { input } });
}